type CurrencyType = '₹' | '$' | '€'

export const currency: CurrencyType = '$'

export const currentYear = new Date().getFullYear()

export const developedByLink = 'https://techzaa.getappui.com/'

export const developedBy = 'Coderthemes'

export const contactUs = 'techzaastudio@gmail.com'

export const buyLink = ''

export const basePath = process.env.NEXT_PUBLIC_BASE_PATH || ''

export const DEFAULT_PAGE_TITLE = 'Manapl  - Manapl Admin Dashboard'

// Staging: https://pnlsystem.ca/api2 — nginx proxies /api2/api/* to the staging backend.
export const API_BASE_PATH = process.env.NEXT_PUBLIC_API_URL || ''

export const colorVariants = ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark', 'purple', 'pink', 'orange', 'light', 'link']
